// Vacancies expand functionality
const expandButtons = document.querySelectorAll('.js-vacancies-expand');

expandButtons.forEach((button) => {
    button.addEventListener('click', () => {
        const section = button.closest('.uecc-vacancies');
        
        if (section) {
            section.classList.add('is-expanded');
            button.style.display = 'none';
        }
    });
});
